module.exports = "/images/CARLOS_ROBERTO_LOPES_BUENO.jpg?1f419fda12bfe36e8b783a573be4edea";